import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";

import moment from "moment";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as loginReducer from "containers/Login/reducer";

import WarningIcon from "images/warning.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

const ChatAppWarning = ({} = {}) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.chatAppWarningWrapper}>
      <div className={styles.chatAppWarningHeader}>
        <div className={styles.chatAppWarningIconWrapper}>
          <FontAwesomeIcon icon={faInfo} />
        </div>
        <div className={styles.chatAppWarningTitle}>
          {"Gemini may have inconsistent responses for automatic questions"}
        </div>
      </div>

      <div className={styles.chatAppWarningBody}>
        <div className={styles.chatAppWarningText}>
          {"We recommend using PaLM 2 for predictable agent behavior with automatic question agent templates."}
        </div>
      </div>
    </div>
  );
};

export default ChatAppWarning;
